import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@material-ui/core";
import { EgretDateRange, LocationDropDown, LocationSimpleDropDown } from "egret";
import { COLORS } from "../../config";
import { getHeader } from "../../redux/slices/headerSlice";
import { getSessions } from "../../redux/slices/sessionsSlice";
import SessionsTable from "./SessionsTable";
import SessionDetailModal from "./SessionDetailModal";
import Loading from "egret/components/EgretLoadable/Loading";

function Sessions(props) {
    const dispatch = useDispatch();
    const [selectedDates, setSelectedDates] = useState(null);
    const [availableLocations, setAvailableLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [spaces, setSpaces] = useState(null);
    const [selectedSpace, setSelectedSpace] = useState(null);

    // Add state for the session detail modal
    const [detailModalOpen, setDetailModalOpen] = useState(false);
    const [selectedSessionDetails, setSelectedSessionDetails] = useState(null);

    const header = useSelector((state) => state.header);
    const sessions = useSelector((state) => state.sessions);
    const { match } = props;

    // Initial header data load
    useEffect(() => {
        let locationId = match.params.locationId;
        if (locationId) {
            let param = `location=` + locationId;
            dispatch(getHeader(param));
        } else {
            dispatch(getHeader());
        }
    }, [dispatch, match.params.locationId]);

    // Update local state when header data changes
    useEffect(() => {
        const headerData = header.data;
        const selected = headerData.selectedLocation;
        if (selected) {
            setSelectedLocation(selected);
        }
        const locations = headerData.availableLocations;
        if (locations) {
            setAvailableLocations(locations);
        }
        setSpaces(headerData.availableSpaces);
    }, [header.data]);

    // Fetch sessions data when parameters change
    useEffect(() => {
        if (selectedLocation) {
            const params = {
                locationId: selectedLocation.id
            };

            if (selectedSpace) {
                params.spaceId = selectedSpace.id;
            }

            if (selectedDates) {
                params.from = selectedDates.from;
                params.to = selectedDates.to;
            }

            dispatch(getSessions(params));
        }
    }, [dispatch, selectedLocation, selectedSpace, selectedDates]);

    const handleLocationChange = (index) => {
        setSelectedLocation(availableLocations[index]);
        const param = `location=` + availableLocations[index].id;
        dispatch(getHeader(param));
    };

    const handleSpaceChange = useCallback((index) => {
        if (index !== null)
            setSelectedSpace(spaces[index]);
        else
            setSelectedSpace(null);
    }, [spaces]);

    const handleChangeDate = (calcRange) => {
        const from = calcRange.startDate.format('YYYY-MM-DD');
        const to = calcRange.endDate.format('YYYY-MM-DD');
        const dates = { 'to': to, 'from': from };
        setSelectedDates(dates);
        console.log(dates);
    };

    // Updated to use data directly from Redux
    const handleViewSession = (sessionId) => {
        // Find the session in the Redux store data
        const sessionDetails = sessions.data.find(session => session.id === sessionId);
        if (sessionDetails) {
            setSelectedSessionDetails(sessionDetails);
            setDetailModalOpen(true);
        }
    };

    // Function to close the detail modal
    const handleCloseDetailModal = () => {
        setDetailModalOpen(false);
    };

    return (
        <div className="m-sm-30 session-container">
            <div className="flex flex-middle mb-30">
                <LocationDropDown
                    locations={availableLocations}
                    selected={selectedLocation}
                    onChange={(index) => handleLocationChange(index)}
                    style={{ marginRight: 30 }}
                />
                <Icon className="mx-20" style={{ color: COLORS.SUCCESS }}>chevron_right</Icon>
                <LocationSimpleDropDown
                    locations={spaces}
                    selected={selectedSpace}
                    onChange={handleSpaceChange}
                    style={{ marginRight: 30 }}
                    label="All Spaces"
                />
                <EgretDateRange onCallback={handleChangeDate} style={{ marginRight: 30 }} />
            </div>
            <div className="session-content">
                {sessions.loading ? (
                    <Loading />
                ) : (
                    <SessionsTable
                        sessions={sessions.data}
                        onViewSession={handleViewSession}
                    />
                )}

                {/* Add the session detail modal */}
                <SessionDetailModal
                    open={detailModalOpen}
                    onClose={handleCloseDetailModal}
                    session={selectedSessionDetails}
                />
            </div>
        </div>
    );
}

export default Sessions;